import { render, staticRenderFns } from "./form3.vue?vue&type=template&id=dd124cbc&scoped=true"
import script from "./form3.vue?vue&type=script&lang=js"
export * from "./form3.vue?vue&type=script&lang=js"
import style0 from "./form3.vue?vue&type=style&index=0&id=dd124cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd124cbc",
  null
  
)

export default component.exports